import React            from 'react';
import {Row, Col, Button, Input}
						from 'reactstrap/';
import { chartService } from '../../services';

class CustomInput extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			value: this.props.initial
		}
	}

	handleChange = (event) => {
		this.setState({value: event.target.value})
		if (this.props.onChange) {
			this.props.onChange(this.props.sourceID, event.target.value)
		}
	}

	render() {
		return (
			<Input placeholder={`The LeadSource from Databowl`} onChange={this.handleChange} value={this.state.value}></Input>
		)
	}
}

class SuppliersList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			formValues: []
		}
	}

	sourceChange = (id, value) => {
		var {formValues} = this.state;
		formValues[id] = value;
		this.setState({formValues: formValues});
	}

	onUpdate = (id) => {
		const {formValues} = this.state;
		var s = this.props.suppliers.find(e => e.LeadSourceID == id);
		s.LeadSource = formValues[id];
		chartService.updateSupplier(id, s);

	}

	render() {
		return (
			<>
				<div>
					<Row>
						<Col xs={4}>
							<div className={`supplier-list--header`}>Name</div>
						</Col>
						<Col xs={2}>
							<div className={`supplier-list--header`}>Cost Per Lead</div>
						</Col>
						<Col xs={4}>
							<div className={`supplier-list--header`}>Lead Source</div>
						</Col>
					</Row>
					{ this.props.suppliers.map(s => {
						if (s.Name == 'Rokkit PM') {
							return null;
						}
						return (
							<Row key={s.LeadSourceID} className={`suppliers-list--supplier--row`}>
								<Col xs={4}>
									<div>{s.Name}</div>
								</Col>
								<Col xs={2}>
									<div>{(s.CostPerLead / 100).toFixed(2)}</div>
								</Col>
								<Col xs={4}>
									<div><CustomInput onChange={this.sourceChange} sourceID={s.LeadSourceID} initial={s.LeadSource} /></div>
								</Col>
								<Col xs={2}>
									<div><Button onClick={() => this.onUpdate(s.LeadSourceID)} size={`sm`}>Update</Button></div>
								</Col>
							</Row>

						)
					})}
				</div>
			</>
		)
	}
}

export default SuppliersList;
